import { get, post } from ".";

export const getSCurveApi = async (projectId, dateTo, contract) => {
  return await get(`project/${projectId}/cost?dateTo=${dateTo}&contractor=${contract}`);
};

export const getEarnValueApi = async (projectId, dateTo) => {
  return await get(`project/${projectId}/cost/earn-value?dateTo=${dateTo}`);
};

export const updateBudgetApi = async (projectId, params) => {
  return await post(`project/${projectId}/cost/update-budget`, params);
};

export const getCPISPIApi = async (projectId, dateTo) => {
  return await get(`project/${projectId}/cost/cpi-spi?dateTo=${dateTo}`);
};

export const getPercentageCompletionApi = async (projectId) => {
  return await get(`project/${projectId}/cost/percentage-completion`);
};
